import {
  PRIVATE_ASSET_MIME_TYPES,
  type PrivateAsset,
  type PrivateAssetRole,
  type PrivateAssetType,
} from '@nest-react/domain';

export type SupportedAssetType = Exclude<PrivateAssetType, 'DOCUMENT'>;

export const classifyAssetFile = (
  file: File
): { type: SupportedAssetType; role: PrivateAssetRole } | null => {
  if ((PRIVATE_ASSET_MIME_TYPES.IMAGE as readonly string[]).includes(file.type))
    return { type: 'IMAGE', role: 'OTHER' };
  if ((PRIVATE_ASSET_MIME_TYPES.VIDEO as readonly string[]).includes(file.type))
    return { type: 'VIDEO', role: 'OTHER' };
  if ((PRIVATE_ASSET_MIME_TYPES.AUDIO as readonly string[]).includes(file.type))
    return { type: 'AUDIO', role: 'OTHER' };
  return null;
};

export const isSupportedAsset = (
  asset: Pick<PrivateAsset, 'type'>
): asset is Pick<PrivateAsset, 'type'> & { type: SupportedAssetType } =>
  asset.type === 'IMAGE' || asset.type === 'VIDEO' || asset.type === 'AUDIO';

export const matchesAssetSearch = (
  asset: Pick<PrivateAsset, 'name'>,
  query: string
): boolean =>
  asset.name.toLocaleLowerCase().includes(query.trim().toLocaleLowerCase());
